import { login, logout, requestPasswordReset } from '@/services/auth';

export default {
  namespaced: true,

  state: {
    localExp: null,
    token: ''
  },

  mutations: {
    CLEAR(state) {
      state.token = '';
      state.localExp = null;
    },

    SET_AUTH(state, payload) {
      state.token = payload.token;
      state.localExp = payload.localExp;
    }
  },

  actions: {
    LOGIN({ commit }, payload) {
      return login(payload)
        .then(result => {
          console.log('LOGIN', result);

          if (result.token) {
            // Store token
            commit('SET_AUTH', result);
          }

          return result;
        })
        .catch(err => {
          return err;
        });
    },

    LOGOUT({ commit }, payload) {
      console.log('LOGOUT', logout);

      return logout()
        .then(response => {
          return response;
        })
        .catch(err => {
          return err;
        });
    },

    RESET_PASSWORD({ commit }, payload) {
      return requestPasswordReset(payload)
        .then(response => {
          return response;
        })
        .catch(err => {
          return err;
        });
    }
  }
};
